import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { BlockedNumbersComponent } from "@onsip/web/features/administrators/pbx-settings/blocked-numbers/blocked-numbers.component";
import { BlockedNumbersRoutingModule } from "@onsip/web/features/administrators/pbx-settings/blocked-numbers/blocked-numbers-routing.module";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { MatSortModule } from "@angular/material/sort";
import { MatTableModule } from "@angular/material/table";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatStepperModule } from "@angular/material/stepper";
import { MatRadioModule } from "@angular/material/radio";
import { MatSelectModule } from "@angular/material/select";
import { MatTabsModule } from "@angular/material/tabs";
import { MatDialogModule } from "@angular/material/dialog";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatDividerModule } from "@angular/material/divider";
import { PipesModule } from "@onsip/web/features/shared/pipes/pipes.module";
import { TranslateModule } from "@ngx-translate/core";
import { RouterModule } from "@angular/router";
import { LoadingContainerComponent } from "@onsip/web/features/shared/components/loadingContainer/loading-container.component";

@NgModule({
  declarations: [BlockedNumbersComponent],
  imports: [
    CommonModule,
    FormsModule,
    BlockedNumbersRoutingModule,
    MatFormFieldModule,
    MatDividerModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    MatSortModule,
    MatTableModule,
    MatPaginatorModule,
    MatStepperModule,
    MatRadioModule,
    MatSelectModule,
    MatTabsModule,
    MatDialogModule,
    PipesModule,
    ReactiveFormsModule,
    TranslateModule,
    LoadingContainerComponent,
    RouterModule
  ]
})
export class BlockedNumbersModule {}
